"use strict";
/*
 * <copyright file="HxInt32Pair.ts" company="Microsoft">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * <summary>
 *   !!! THIS FILE IS GENERATED BY OBJECTGEN TOOL. DO NOT EDIT BY HAND. !!!
 *   PropertyTypeJs.tt generates this file.
 * </summary>
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxInt32Pair = exports.deserializeHxInt32Pair = void 0;
function deserializeHxInt32Pair(values) {
    if (values.length !== 2) {
        throw new Error('Found ' + values.length + ' prop in HxInt32Pair');
    }
    var first = values[0];
    var second = values[1];
    return { first: first, second: second };
}
exports.deserializeHxInt32Pair = deserializeHxInt32Pair;
function serializeHxInt32Pair(arg) {
    var output = [];
    output.push(arg.first);
    output.push(arg.second);
    return output;
}
exports.serializeHxInt32Pair = serializeHxInt32Pair;
